import * as THREE from "three";
import { EffectComposer } from "three/addons/postprocessing/EffectComposer.js";
import { RenderPass } from "three/addons/postprocessing/RenderPass.js";
import { GlitchPass } from "three/addons/postprocessing/GlitchPass.js";
import { OutputPass } from "three/addons/postprocessing/OutputPass.js";

export default function ContentErrorscene(renderer) {
    let camera, scene, clock, composer;
    const width = window.innerWidth,
      height = window.innerHeight;

    camera = new THREE.PerspectiveCamera(70, width / height, 0.01, 10);
    camera.position.z = 0.3;
    camera.position.y = 0.4;
    scene = new THREE.Scene();
    const size = 200;
    const divisions = 500;
    //cant change remove and find alternative
    const gridHelper = new THREE.GridHelper(size, divisions, 0x880808, 0x880808);
    scene.add(gridHelper);
    clock = new THREE.Clock();
    scene.camera = camera


    return scene

}